import React, { useState } from "react";
import ReportTable from "./subComponents/reportTable";
import ReportFilters from "./subComponents/reportFilter";
import { columnsConfig } from "./reportColumns";

const PurchaseReport = () => {
    const [filterInputs, setFilterInputs] = useState({
        fromDate: "",
        toDate: ""
    });

    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: ""
    });

    const handleApplyFilters = () => {
        setFilters(filterInputs);
    };

    const handleResetFilters = () => {
        const empty = { fromDate: "", toDate: "" };
        setFilterInputs(empty);
        setFilters(empty);
    };

    return (
        <>
            <ReportFilters
                filters={filterInputs}
                setFilters={setFilterInputs}
                onApply={handleApplyFilters}
                onReset={handleResetFilters}
            />
            <ReportTable
                title="Payment Purchase Report"
                endpoint="Vyapar/Purchase/purchase-report"
                columns={columnsConfig.purchaseReport}
                filters={filters}
                nestedColumnValue="purchaseItems"
            />
        </>
    );
};

export default PurchaseReport;